import { render, staticRenderFns } from "./OfertaEmprendedores.vue?vue&type=template&id=00d95826&scoped=true"
import script from "./OfertaEmprendedores.vue?vue&type=script&lang=js"
export * from "./OfertaEmprendedores.vue?vue&type=script&lang=js"
import style0 from "./OfertaEmprendedores.vue?vue&type=style&index=0&id=00d95826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d95826",
  null
  
)

export default component.exports